import { configureStore } from '@reduxjs/toolkit';
import menuReducer from '../slices/menu/MenuSlice';
import userReducer from '../slices/user/UserSlice';
import errorReducer from '../slices/error/ErrorSlice';
import accessReducer from '../slices/error/AccessSlice';
import appReducer from '../slices/app/AppSlice';
import vocReducer from '../slices/voc/VocSlice';
import { apiSlice} from '../slices/api/apiSlice'

export default configureStore({
    reducer: {
        menu: menuReducer,
        user: userReducer,
        error: errorReducer,
        access: accessReducer,
        app: appReducer,
        voc: vocReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            apiSlice.middleware,
        ),
})